module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isBuyForWoman) ? _c('div', [_c('div', {
    staticClass: "box-data"
  }, [_c('h3', {
    staticClass: "title-content"
  }, [_vm._v(_vm._s(_vm.$t('CAN_I_USE_BRASTER')))]), _vm._v(" "), _c('BrasterAllowed')], 1), _vm._v(" "), _c('div', {
    staticClass: "box-data",
    attrs: {
      "id": "CzynnikiRyzyka"
    }
  }, [_c('h3', {
    staticClass: "title-content"
  }, [_vm._v(_vm._s(_vm.$t('RISK_FACTORS')))]), _vm._v(" "), _c('RiskFactors')], 1), _vm._v(" "), _c('div', {
    staticClass: "box-data",
    attrs: {
      "id": "DaneMedyczne"
    }
  }, [_c('h3', {
    staticClass: "title-content"
  }, [_vm._v(_vm._s(_vm.$t('MEDICAL_DATA')))]), _vm._v(" "), _c('MedicalData')], 1), _vm._v(" "), _c('div', {
    staticClass: "box-data",
    attrs: {
      "id": "DanePersonalne"
    }
  }, [_c('h3', {
    staticClass: "title-content"
  }, [_vm._v(_vm._s(_vm.$t('PERSONAL_DATA')))]), _vm._v(" "), _c('PersonalData')], 1), _vm._v(" "), _c('div', {
    staticClass: "box-data",
    attrs: {
      "id": "DodatkoweInformacje"
    }
  }, [_c('h3', {
    staticClass: "title-content"
  }, [_vm._v(_vm._s(_vm.$t('ADDITIONAL_MEDICAL_DATA')))]), _vm._v(" "), _c('AdditionalDocument')], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f2c6750","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/my-data/my-medical-data.vue
// module id = 1224
// module chunks = 0